// SPK (Surat Perintah Kerja) as native ESC/P for the Epson LX-310.
// Content mirrors the HTML version in ../printSPKUtils.js (3-line info block:
// Tanggal/No SPK left; Kepada/UP./Alamat right); the page layout (boxed table,
// page numbers, footer) is rendered by halfFormEscp.js.

import {
  buildHalfFormDoc,
  STANDARD_COLUMNS,
  STANDARD_TOTALS,
} from "./halfFormEscp";

const fmtDate = (data) => {
  const raw = data.created_at;
  if (!raw) return "-";
  const d = new Date(raw);
  return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("id-ID");
};

const CONFIG = {
  title: "SURAT PERINTAH KERJA (SPK)",
  infoLines: (data) => [
    ["Tanggal", fmtDate(data), "Kepada", data.customer_name || "-"],
    [
      "No SPK",
      data.document_number || data.spk_number || data.id,
      "UP.",
      data.customer_upline || "-",
    ],
    ["", "", "Alamat", data.customer_address || "-"],
  ],
  infoLabelWidth: 10,
  columns: STANDARD_COLUMNS,
  groupHeader: { label: "JUMLAH", span: 2 },
  totalSpan: 5,
  totals: STANDARD_TOTALS,
  notes: (data) => data.notes || "-",
  signatureLabel: "Yang membuat,",
  signatureName: (data) => data.user_username || "(_______________)",
  maxItemsPerPage: 7,
};

/**
 * Build the full ESC/P document string for an SPK.
 * @param {object} data the same data object passed to printSPK()
 * @param {number} itemsPerPage rows per page (matches the HTML paginator)
 * @returns {string} ESC/P bytes ready for qzClient.printRaw()
 */
export const buildSPKEscp = (data, itemsPerPage = 6) =>
  buildHalfFormDoc(CONFIG, data, itemsPerPage);

export default buildSPKEscp;
